// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.content-container[data-v-0220be05] .player-container {\n\theight: 100%;\n}\n.content-container[data-v-0220be05] video.container-size {\n\twidth: 100% !important;\n\theight: 100% !important;\n\t-o-object-fit: cover !important;\n\t   object-fit: cover !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
